import {useAuth0} from "@auth0/auth0-react";

export function useAnimalAPI() {
    const {getAccessTokenSilently} = useAuth0();

    const getAnimals = async () => {
        try {
            const accessToken = await getAccessTokenSilently();

            const response = await fetch(`${process.env.REACT_APP_BACK_API}/animal`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            // await delay(250);
            // loginWithRedirect();
        }
    };

    const getAnimalByUuid = async (uuid) => {
        try {
            const accessToken = await getAccessTokenSilently();

            const response = await fetch(`${process.env.REACT_APP_BACK_API}/animal/${uuid}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching personal information:', error);
            throw error;
        }
    };

    const createOrUpdateAnimal = async (animal, reservationUuid) => {
        if (animal.id) {
            return updateAnimal(animal)
        } else {
            return createAnimal(animal, reservationUuid)
        }
    }

    const createAnimal = async (animal, reservationUuid) => {
        try {
            const accessToken = await getAccessTokenSilently();

            const reservationPath = reservationUuid !== undefined ? '/' + reservationUuid : '';
            const response = await fetch(`${process.env.REACT_APP_BACK_API}/animal${reservationPath}`, {
                method: 'POST',
                headers: {
                    "Content-type": 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(animal)
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            // console.error('Error fetching personal information:', error);
            throw error;
        }
    };

    const updateAnimal = async (animal) => {
        try {
            const accessToken = await getAccessTokenSilently();

            const response = await fetch(`${process.env.REACT_APP_BACK_API}/animal`, {
                method: 'PUT',
                headers: {
                    "Content-type": 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(animal)
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching personal information:', error);
            throw error;
        }
    };

    const archiveAnimal = async (uuid) => {
        try {
            const accessToken = await getAccessTokenSilently();

            const response = await fetch(`${process.env.REACT_APP_BACK_API}/animal/${uuid}/archive`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error archiving animal:', error);
            throw error;
        }
    };

    return {getAnimals, createAnimal, updateAnimal, createOrUpdateAnimal, getAnimalByUuid, archiveAnimal};
}
